import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import English from '../assets/flags/EN.svg';
import Spanish from '../assets/flags/ES.svg';
import Portuguese from '../assets/flags/PT.svg';
import CheckIcon from '../assets/icons/Check.svg';
import ArrowDown from '../assets/icons/ArrowDown.svg';
import './SelectLanguage.scss';

const SelectLanguage = () => {
  const { i18n } = useTranslation();

  const currentLanguage = localStorage.getItem('i18nextLng');

  // State management
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [isI18nReady, setIsI18nReady] = useState(false);

  const selectRef = useRef(null);

  const options = [
    { value: 'en-US', label: 'English', flag: English },
    { value: 'es-MX', label: 'Español', flag: Spanish },
    { value: 'pt-BR', label: 'Português', flag: Portuguese },
  ];

  const mapLanguage = (lng) => {
    if (lng.startsWith('en')) return 'en-US';
    if (lng.startsWith('es')) return 'es-MX';
    if (lng.startsWith('pt')) return 'pt-BR';
    return 'en-US'; // Default fallback
  };

  useEffect(() => {
    const handleInitialLanguage = () => {
      const detectedLanguage = mapLanguage(
        currentLanguage || i18n.language || 'en-US'
      );
      setSelectedOption(detectedLanguage);
      setIsI18nReady(true);
    };

    if (i18n.isInitialized) {
      handleInitialLanguage();
    } else {
      i18n.on('initialized', handleInitialLanguage);
    }

    return () => i18n.off('initialized');
  }, [i18n]);

  const handleOptionClick = (value) => {
    setSelectedOption(value);
    i18n.changeLanguage(value);
    localStorage.setItem('i18nextLng', value);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Find the selected option
  const selected = options.find((option) => option.value === selectedOption);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <div className="header__lang custom-select-wrapper" ref={selectRef}>
      <div className="custom-select">
        <div
          className="custom-select-trigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          {selected && (
            <>
              <img
                src={selected.flag}
                alt="Selected language"
                className="flag-icon"
              />
              <span>{selected.label}</span>
            </>
          )}
          <img
            src={ArrowDown}
            alt="Dropdown arrow"
            className="arrow-icon"
            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
          />
        </div>
        <div className={`custom-options ${isOpen ? 'open' : ''}`}>
          {options.map((option) => (
            <div
              key={option.value}
              className={`custom-option ${
                option.value === selectedOption ? 'selected' : ''
              }`}
              onClick={() => handleOptionClick(option.value)}
              data-value={option.value}
            >
              <img src={option.flag} alt={option.label} className="flag-icon" />
              <span>{option.label}</span>
              {option.value === selectedOption && (
                <img src={CheckIcon} alt="Selected" className="check-icon" />
              )}
            </div>
          ))}
        </div>
      </div>
      <input type="hidden" name="lang" id="lang" value={selectedOption} />
    </div>
  );
};

export default SelectLanguage;
